import { RestAPI, Auth } from './proxies';

export const createLeague = async (data) => {
    try {
        const result = await RestAPI.post('/api/leagues/create', data);
        if (result && result.success) {
            return result['data'];
        } else {
            throw new Error(`Failed to create league - ${result.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const updateLeague = async (data) => {
    try {
        const result = await RestAPI.post('/api/leagues/update', data);
        if (result && result.success) {
            return result['data'];
        } else {
            throw new Error(`Failed to update league - ${result.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getLeague = async (leagueID) => {
    try {
        const response = await RestAPI.get(`/api/leagues/${leagueID}`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get league: ${leagueID} because ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

const fetchTeamData = async (leagueID, teamID, suffix = '') => {
    try {
        const response = await RestAPI.get(`/api/leagues/${leagueID}/teams/${teamID}${suffix}`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get team: ${leagueID}/${teamID} because ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getTeam = async (leagueID, teamID) => fetchTeamData(leagueID, teamID);

export const getSquadView = async (leagueID, teamID) => fetchTeamData(leagueID, teamID, '/squad');

export const setAuctionTeam = async (leagueID, squadName, gameWeek, players) => {
    const params = {
        leagueID: leagueID,
        gameWeek: gameWeek,
        squadName: squadName,
        players: players,
    };
    try {
        const response = await RestAPI.post(`/api/leagues/setteam`, params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to setAuctionTeam - ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const addCaptain = async (leagueID, squadName, matchID, playerID, triple) => {
    const params = {
        leagueID,
        squadName,
        matchID,
        playerID,
        triple
    };
    try {
        const response = await RestAPI.post(`/api/leagues/addcaptain`, params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to add captain - ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const removeCaptain = async (leagueID, squadName, matchID, playerID, triple) => {
    const params = {
        leagueID,
        squadName,
        matchID,
        playerID,
        triple
    };
    try {
        const response = await RestAPI.post(`/api/leagues/removecaptain`, params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to remove captain - ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const addSquad = async (data) => {
    try {
        const response = await RestAPI.post(`/api/leagues/addsquad`, data);
        if (response.success) {
            return response.data;
        } else {
            throw new Error(`Failed to add to squad: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const removeFromSquad = async (data) => {
    try {
        const response = await RestAPI.post(`/api/leagues/removesquad`, data);
        if (response.success) {
            return response.data;
        } else {
            throw new Error(`Failed to remove from squad: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const makeSubs = async (leagueID, gameWeek, subs) => {
    const params = {
        leagueID,
        gameWeek,
        subs
    };
    try {
        const response = await RestAPI.post(`/api/leagues/subs`, params);
        if (response.success) {
            return response;
        } else {
            throw new Error(`Failed to make subs: ${response.error}`)
        }
    } catch (err) {
        throw err;
    }
};


export const getInviteToken = async (data) => {
    try {
        const response = await RestAPI.post(`/api/invite`, data);
        if (response && response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get invite token - ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const viewToken = async (tokenCode) => {
    try {
        const response = await RestAPI.get(`/api/invite/${tokenCode}`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to read token: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const joinWithToken = async (tokenCode) => {
    try {
        const result = await RestAPI.post('/api/leagues/join', { token: tokenCode });
        if (result && result.success) {
            return result['data'];
        } else {
            throw new Error(`Failed to join league - ${result.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getTournaments = async () => {
    try {
        const response = await RestAPI.get('/api/tournaments');
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get tournaments - ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getAuctionView = async (leagueID) => {
    try {
        const response = await RestAPI.get(`/api/leagues/${leagueID}/auction`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get auction view: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const auctionBid = async (leagueID, squadName, playerID, price) => {
    const params = { leagueID, squadName, playerID, price };
    try {
        const response = await RestAPI.post('/api/leagues/auctionbid', params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to place auction bid: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getSnakeDraftView = async (leagueID) => {
    try {
        const response = await RestAPI.get(`/api/leagues/${leagueID}/snake-draft`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get snake draft view: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const setSnakeDraftOrder = async (leagueID, order) => {
    const params = { leagueID, order };
    try {
        const response = await RestAPI.post('/api/leagues/snake-draft/order', params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to set draft order: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const snakeDraftPick = async (leagueID, squadName, playerID) => {
    const params = { leagueID, squadName, playerID };
    try {
        const response = await RestAPI.post('/api/leagues/snake-draft/pick', params);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to make draft pick: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};
